import React from 'react'
import Layout from '../../components/common/pageLayout'
import Form from '../../components/WareHouse/add'
import constant from '../../constant'
import { toast } from 'react-toastify'
import { v3_add_warehouse } from '../../actions/v3/wareHouseManagement'
const Add = (props) => {

    const onSubmit = (model) => {
        v3_add_warehouse(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                props.history.push(constant.Authedcomponent.listWareHouse.url)
            }
            else {
                toast.error(res.error)

            }
        })
    }
    const onCancel = () => {
        props.history.push(constant.Authedcomponent.listWareHouse.url);
    }
    return (
        <React.Fragment>
            <Layout
                title={'Add Warehouse'}
            >
                <Form
                    title={'Add Warehouse'}
                    onSubmit={onSubmit}
                    buttonName={'Create Warehouse'}
                    onCancel={onCancel}

                />
            </Layout>
        </React.Fragment>
    )
}

export default Add